module.exports = __webpack_public_path__ + "static/media/RRD-min.a93513a7.webp";